import { BoardColumnType, BoardConfigurationType } from "@/common/interfaces";
import moment from "moment";
import { Moment } from "moment";

export declare type StoredBoardLoadedState = 'info' | 'columns' | 'configuration' | 'participants';

export class Column {
	readonly uuid: string;
	name: string;
	index: number;
	emoji: string | null;
	participantsCanAddCards: boolean;

	constructor(column: BoardColumnType) {
		this.uuid = column.uuid;
		this.name = column.name;
		this.index = column.index;
		this.emoji = column.emoji;
		this.participantsCanAddCards = column.participantsCanAddCards;
	}
}

export class Configuration {
	cardLimit: number = 0;
	voteLimit: number = 0;
	hideCards: boolean = false;
	hideVotes: boolean = false;
	hideCardAuthors: boolean = false;
	comments: boolean = true;
	anonymousCards: boolean = false;
	showActiveUsers: boolean = true;
	introText: {[key: string]: any} | null = null;
	introRenderedText: string | null = null;
	introTitle: string | null = null;
	welcomeScreenEnabled: boolean = false;

	closeDate: Date | null = null;

	constructor(configuration: BoardConfigurationType) {
		this.fromConfigurationType(configuration);
	}

	fromConfigurationType(configuration: BoardConfigurationType) {
		this.cardLimit = configuration.cardLimit;
		this.voteLimit = configuration.voteLimit;
		this.hideCards = configuration.hideCards;
		this.hideVotes = configuration.hideVotes;
		this.hideCardAuthors = configuration.hideCardAuthors;
		this.comments = configuration.comments;
		this.anonymousCards = configuration.anonymousCards;
		this.showActiveUsers = configuration.showActiveUsers;
		this.introText = (configuration.introText !== null)?
			JSON.parse(configuration.introText)
			: null;
		this.introRenderedText = configuration.introRenderedText;
		this.introTitle = configuration.introTitle;
		this.welcomeScreenEnabled = configuration.welcomeScreenEnabled;

		if (configuration.closeDate !== null) {
			this.closeDate = new Date(
				Date.parse(configuration.closeDate)
			);
		}
	}

	update(configuration: BoardConfigurationType) {
		this.fromConfigurationType(configuration);
	}
}
